var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoQrcode01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2644",
    transform: "translate(0 0.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1469",
    d: "M11.3,0.7H0.5v10.8h10.8V0.7z M9.2,9.3H2.7V2.9h6.5V9.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_469",
    x: 5.3,
    y: 5,
    width: 1.6,
    height: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1470",
    d: "M24.2,0.7v10.8H35V0.7H24.2z M32.8,9.3h-6.5V2.9h6.5V9.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_470",
    x: 29.1,
    y: 5,
    width: 1.6,
    height: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1471",
    d: "M0.5,35.2h10.8V24.4H0.5V35.2z M2.7,26.6h6.5V33H2.7V26.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_471",
    x: 5.3,
    y: 28.8,
    width: 1.6,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_472",
    x: 18,
    y: 0.2,
    width: 4.8,
    height: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1472",
    d: "M17.8,9.3h2.2V7.2h2.2V5h-6.5V2.9h-2.2v4.3h4.3V9.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_473",
    x: 13.2,
    y: 9.8,
    width: 1.6,
    height: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1473",
    d: "M22.1,11.5h-2.2v2.2h-6.5v2.2h8.6V11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1474",
    d: "M2.7,20.1h2.2v-2.2H2.7v-4.3H0.5v8.6h2.2V20.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_474",
    x: 5.3,
    y: 12.9,
    width: 1.6,
    height: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1475",
    d: "M13.5,22.2h4.3v-2.2h-2.2v-2.2h-4.3v-4.3H9.2v4.3H7v4.3h2.2v-2.2h4.3L13.5,22.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_475",
    x: 19.6,
    y: 17.7,
    width: 3.2,
    height: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1476",
    d: "M19.9,24.4h-6.5v2.2h4.3V33h-4.3v2.2h6.5V33h4.3v-2.2h-4.3V24.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_476",
    x: 13.2,
    y: 28.8,
    width: 1.6,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_477",
    x: 22.8,
    y: 24.1,
    width: 1.6,
    height: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1477",
    d: "M32.8,28.7h-6.5v6.5h2.2v-4.3h4.3L32.8,28.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_478",
    x: 30.7,
    y: 33.6,
    width: 4.8,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_479",
    x: 32.3,
    y: 24.1,
    width: 3.2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1478",
    d: "M26.4,26.6h2.2v-6.5h-4.3v2.2h2.2V26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1479",
    d: "M30.7,15.8h-2.2v-2.2h-2.2v2.2h-2.2v2.2h8.6v-2.2H35v-2.2h-4.3V15.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_480",
    x: 30.7,
    y: 20.9,
    width: 4.8,
    height: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoQrcode01);
export default __webpack_public_path__ + "static/media/ico-qrcode-01.01dde4869e20b51fc4f9cc562df3caea.svg";
export { ForwardRef as ReactComponent };